import React, { useState, useEffect } from 'react';

import { IntlProvider, MessageFormatElement } from 'react-intl';
import useConfig from 'hooks/useConfig';

const loadLocaleData = (locale: string) => {
    switch (locale) {
        case 'en-GB':
            return import('utils/locales/en-GB.json');
        case 'fr-FR':
            return import('utils/locales/fr-FR.json');
        case 'pt-PT':
            return import('utils/locales/pt-PT.json');
        case 'pt-BR':
            return import('utils/locales/pt-BR.json');
        case 'it':
            return import('utils/locales/it.json');
        case 'de':
            return import('utils/locales/de.json');
        default:
            return import('utils/locales/es-ES.json');
    }
};

interface LocalsProps {
    children: React.ReactNode;
}

const Locales = ({ children }: LocalsProps) => {
    const { locale } = useConfig();
    const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();
    const defaultLocale = 'es-ES';

    useEffect(() => {
        loadLocaleData(locale).then((d: { default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined }) => {
            setMessages(d.default);
        });
    }, [locale]);

    return (
        <>
            {messages && (
                <IntlProvider locale={locale} defaultLocale={defaultLocale} messages={messages}>
                    {children}
                </IntlProvider>
            )}
        </>
    );
};

export default Locales;
